import { useReports } from "@sail/observability";
import { useCallback, useEffect, useState } from "react";
/**
 * Hook for persisting data in the browser storage, supports both localStorage and sessionStorage.
 *
 */ export default function useBrowserStorage(/* The config object to inject to the storage functions */ config, /* Abstraction over the desired browser storage */ storage, /* Key of storage item to interact with */ key) {
    const reports = useReports();
    const [value, setValueInternal] = useState(()=>storage.get(config, key, reports));
    const setItem = useCallback((value)=>{
        return storage.set(config, key, value, reports);
    }, [
        config,
        key,
        storage,
        reports
    ]);
    useEffect(()=>{
        function onChange(event) {
            switch(event.type){
                case 'clear':
                    {
                        setValueInternal(null);
                        break;
                    }
                case 'remove':
                    {
                        if (event.key === key) {
                            setValueInternal(null);
                        }
                        break;
                    }
                case 'set':
                    {
                        if (event.key === key) {
                            setValueInternal(event.value);
                        }
                        break;
                    }
                default:
                    break;
            }
        }
        storage.subscribe(config, onChange, reports);
        return ()=>{
            storage.unsubscribe(config, onChange, reports);
        };
    }, [
        config,
        key,
        storage,
        reports
    ]);
    return [
        value !== null && value !== void 0 ? value : null,
        setItem
    ];
}

//# sourceMappingURL=useBrowserStorage.js.map